import { AuditUser } from 'services/user/user.model';
import { MOCK_PEOPLE } from '../shared/mock-context.const';
import { buildCurrentUser } from '../session/session.mock';

/** Persona logada no protótipo, no formato de auditoria (autor de revisões e versões) */
export function currentMockUser(): AuditUser {
	try {
		const user = buildCurrentUser();
		return { id: user.id, name: user.name, email: user.email, image: user.image ?? null };
	} catch {
		return MOCK_PEOPLE.operador;
	}
}
